import React, { useContext } from 'react';

//material ui
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';

//global state
import { StateContext } from '../../AppStateContext';

//components
import CopyRight from './CopyRight';
import LoginFormContentHeader from './LoginFormContentHeader';
import LoginFormContentWCS from './LoginFormContentWCS';
import LoginFormContentDivider from './LoginFormContentDivider';
import LoginFormContentSelfHostedWeaviate from './LoginFormContentSelfHostedWeaviate';
import LoginFormContentBottomText from './LoginFormContentBottomText';

const LoginFormContent = ({
  classes,
  handleWcsRegister,
  handleWscLogin,
  handleChange,
  handleClick,
}) => {
  //consume global state
  const state = useContext(StateContext);

  //to handle when user clicks the enter keyboard
  const handleEnterKeyPress = (e) => {
    if (state.connectToWeaviateURI) {
      handleClick(e);
    } else {
      handleWscLogin(e);
    }
  };

  return (
    <Paper elevation={10} className={classes.outer}>
      <Container component='main' maxWidth='xs' className='login'>
        <LoginFormContentHeader classes={classes} />

        <form
          onSubmit={handleEnterKeyPress}
          className={classes.form}
          noValidate
          autoComplete='off'
        >
          <LoginFormContentWCS
            classes={classes}
            handleWscLogin={handleWscLogin}
            handleWcsRegister={handleWcsRegister}
          />
          <LoginFormContentDivider classes={classes} />
          <LoginFormContentSelfHostedWeaviate
            classes={classes}
            handleClick={handleClick}
            handleChange={handleChange}
          />
        </form>

        <LoginFormContentBottomText classes={classes} />
        <Box mt={8} style={{ marginTop: '50px' }}>
          <CopyRight />
        </Box>
      </Container>
    </Paper>
  );
};

export default LoginFormContent;
